import { CONST } from '@common/constants/const.constant';
import { ICollectionRequestOptions } from '@common/interfaces/collection-request-options.interface';
import { ICollection } from '@common/interfaces/collection.interface';
import { IIdObject } from '@common/interfaces/id-object.interface';
import { UID } from '@common/interfaces/uid.interface';
import { throwException } from './throw-exception.util';

export function createCollection<T, TFilter = unknown>(
    data: T[] | undefined,
    next_page: number | undefined,
    request: (Omit<ICollectionRequestOptions<TFilter>, 'limit'> & { limit?: number }) | undefined,
): ICollection<T, TFilter> {
    return {
        request: { ...request, limit: request?.limit || CONST.LIST_LIMIT },
        next_page: next_page || 0,
        list: data || [],
    };
}

export function deleteFromCollection<T extends IIdObject>(data: ICollection<T> | undefined, id: UID): ICollection<T> {
    if (!data) {
        return createCollection([], 0, {});
    }
    return {
        ...data,
        list: data?.list.filter((f) => f.id !== id),
    };
}

export function addToCollection<T extends IIdObject>(data: ICollection<T> | undefined, item: T): ICollection<T> {
    if (!data) {
        return createCollection([item], 0, {});
    }
    return {
        ...data,
        list: [item, ...data.list],
    };
}

export function getItem<T extends IIdObject>(data: ICollection<T> | undefined, id: UID): T | undefined {
    return data?.list.find((item): T | undefined => {
        if (item.id === id) {
            return item;
        }
        return undefined;
    });
}

export function updateCollection<T extends IIdObject>(
    data: ICollection<T> | undefined,
    id: UID,
    newItem: T,
): ICollection<T> {
    if (!data) {
        return createCollection([newItem], 0, {});
    }
    let found = false;
    const res = {
        ...data,
        list: data?.list.map((item) => {
            if (item.id === id) {
                found = true;
                return { ...newItem };
            }
            return item;
        }),
    };
    if (!found) {
        throwException('update collection not found');
    }
    return res;
}
